import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tyreops_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const cid = localStorage.getItem("tyreops_customer_id");
  if (cid) config.headers["X-Customer-Id"] = cid;
  return config;
});

export default api;
